module.exports = __webpack_public_path__ + "static/media/logo-cgl-dark.ec5ad3ec.svg";